import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IButtonExtended } from '@components/button/interfaces/button.interface';
import { IOutputEventData } from '@components/buttons-panel/buttons-panel.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'app-menu-button [buttonConf]',
    templateUrl: './menu-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuButtonComponent<T> {
    @Input() public buttonConf: IButtonExtended;
    @Input() public buttons$: Observable<IButtonExtended[]> = new BehaviorSubject<IButtonExtended[]>([]);
    @Output() public buttonClick = new EventEmitter<IOutputEventData<T>>();
}
